import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'sky-checkbox[label][control]',
  template: `
    <label class="flex items-center relative">
      <button
        class="focus:outline-none border flex-shrink-0 rounded-full flex items-center h-6 w-10 px-1"
        [ngClass]="{
          'justify-end': control.value,
          'justify-start': !control.value,
          'bg-sky-blue border-sky-blue': !control.disabled && control.value,
          'bg-white border-sky-grey': !control.value || control.disabled
        }"
        [class.cursor-pointer]="!control.disabled"
      >
        <span
          class="rounded-full border w-5 h-5 shadow"
          [ngClass]="{
            'border-white bg-white': !control.disabled && control.value,
            'border-gray-300 bg-gray-300': !control.value || control.disabled
          }"
        >
        </span>
      </button>
      <span class="ml-2">
        <span [innerHTML]="label" [class.text-sky-grey]="control.disabled"> </span>
      </span>
      <input class="absolute w-full h-full opacity-0 left-0" [formControl]="control" type="checkbox" />
    </label>
    <div
      *ngIf="control.validator"
      class="text-sky-red text-xs mb-4 h-3"
      [class.invalid-control]="control.touched && control.invalid"
    >
      extends SkyFormControlInputBase
      <ng-container *ngIf="control.touched && control.invalid"> Regulamin musi zostac zaakceptowany </ng-container>
    </div>
  `,
})
export class SkyFormControlCheckboxComponent {
  @Input() public label!: string;
  @Input() public control!: FormControl;
}
